import React from 'react';
import PropTypes from 'prop-types';

import { postCodeAlertMessage } from '../../config/AppConfigurator';
import { AlertMessage } from '../../components/AlertMessage/AlertMessage';
import { AddressList } from '../../components/AddressList/AddressList';
import { SelectedAddress } from '../../components/SelectedAddress/SelectedAddress';

/* IMPORTING LOCAL STYLES FOR POSTCODE */ 
import '../../assets/components/Postcode.scss';

export const Postcode = ({ 
    regex, 
    postcode='', 
    addressesList,  
    fetchingAddresses, 
    queryBtnSpinner, 
    selectedAddress, 
    addressBtnSpinner, 
    showSubmit,
    fetchAddressList, 
    getPostalcode, 
    resetSelectedAddress, 
    getSelectedAddress, 
    getMeterDataEnquiryDetails 
}) => {

    const buttonValidation = postcode.length === 5 || postcode.length === 6 || postcode.length === 7;
    
    return (
        <>
            <div className="mb-3">
                <label htmlFor="InputPostcode" className="form-label">Search by Property Postcode</label>
                <input type="text" className="form-control postcode-input" value={postcode} id="InputPostcode" aria-describedby="postcodeHelp" onChange={event => getPostalcode(event)}/>
            </div>
            { postcode.length > 0 && postcode.length > 7 &&
                <div className="postcode-input">
                    <AlertMessage {...postCodeAlertMessage} />
                </div>
            }
            { showSubmit &&
            <button disabled={ !buttonValidation } className="btn btn-primary btn-md postcode-submit-button" onClick={()=>fetchAddressList()}>
                { addressBtnSpinner ? 
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    : 
                    'Submit'
                }
            </button>
            }
            <div className="meter-data-enquiry-panel-component-divider"></div>
            { fetchingAddresses &&
                <div data-testid="selected-address">
                    { selectedAddress && selectedAddress.length > 0 ? 
                        <SelectedAddress selectedAddress={ selectedAddress } resetSelectedAddress={ resetSelectedAddress } /> 
                        :
                        <div className="postcode-input">
                            <AddressList addressList={ addressesList } getSelectedAddress={ getSelectedAddress } />
                        </div>
                    }
                </div>
            }
            { selectedAddress && selectedAddress.length > 0 &&
                <div data-testid="enquire-button" className="meter-data-enquiry-postcode-query-btn">
                    <button type="button" className="btn btn-primary btn-lg postcode-query-button" onClick={()=>getMeterDataEnquiryDetails()}>
                    { queryBtnSpinner ? 
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        : 
                        'Enquire'
                    }
                    </button>
                </div>
            } 
        </>
    );
};

Postcode.propTypes = {
    /* 
      regex for UK postal code
    */ 
      regex: PropTypes.string.isRequired,
    /* 
      postcode for the component
    */ 
      postcode: PropTypes.string.isRequired,
    /* 
      address list for the component
    */ 
      addressesList: PropTypes.array.isRequired,
    /* 
      fetching address for address list component
    */ 
      fetchingAddresses: PropTypes.bool.isRequired,
    /* 
      query button spinner for query button
    */ 
      queryBtnSpinner: PropTypes.bool.isRequired,
    /* 
      selected address for address list
    */ 
      selectedAddress: PropTypes.string.isRequired,
    /* 
      spinner for submitting postcode
    */ 
      addressBtnSpinner: PropTypes.bool.isRequired,
  }
  
  Postcode.defaultProps = {
    /*
        default value if Regex is not given
    */
      regex: '',
    /*
        default value if postcode is not given
    */
      postcode: '',
    /*
        default value if address list is not given
    */
      addressesList: [],
    /*
        default value for fetching address is not given
    */
      fetchingAddresses: false,
    /*
        default value if query button spinner is not given
    */
      queryBtnSpinner: false,
    /*
        default value if selected address is not given
    */
      selectedAddress: '',
    /*
        default value if address button spinner is not given
    */
      addressBtnSpinner: false,
}